import { createFileRoute } from '@tanstack/react-router'

import UpdaterSectionPage from '@/features/Admin/UpdaterManagement/Components/UpdaterSectionPage.tsx'

export const Route = createFileRoute('/_authenticated/admin/updates/pending')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <UpdaterSectionPage
            status="pending"
            titleKey="admin.updater.updatesPending.title"
            descriptionKey="admin.updater.updatesPending.description"
        />
    )
}
